import { Button, IconButton, Typography } from "@material-ui/core";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TabPanel from "@mui/lab/TabPanel";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  styled,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormGroup from "@mui/material/FormGroup";
import Tab from "@mui/material/Tab";
import axios from "axios";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CommonUtil from "../../Util/CommonUtils";
import CustomTextfeild from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import PlanPurchaseDialogBox from "../../components/DialogBoxComponent/PlanPurchaseDialogBox";
import SelectPlanDialogBox from "../../components/DialogBoxComponent/SelectPlanDialogBox";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import {
  CreateCustomerCompany,
  updateCustomerAccount,
} from "../../slices/Customer/CustomerSlice";
import {
  getAssignedProducts,
  purchasedProducts,
} from "../../slices/ProductSlice/ProductSlice";
import { getCustomerSubscription } from "../../slices/Subscription/SubscriptionSlice";
import { getUserInfoPro } from "../../slices/User/UserSlice1";
import PaymentIcon from "../Dealer/PaymentIcon";
import ProfileIcon from "../Dealer/ProfileIcon";
import ProfileUplod from "../Employee/UploadImg";
import SelfRegistrationCustomPhone from "../OnBoardV2/SelfRegistrationCustomPhone";
import { countryData } from "../Person/AddressFormData";

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

function CreateCustomer(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [parentCompanyCountry, setParentCompanyCountry] = useState("");
  const [customerSubscription, setCurrentSubscription] = useState([]);
  const [assignedSubscription, setAssignedSubscription] = useState();
  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneCountryCode: "",
    phone: "",
    name: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    profile: "",
    level: "",
    companyLogo: "",
    status: "",
    companyId: "",
    companyImageData: "",
    billingStartDate: CommonUtil.formatToUtc(),
    billingEndDate: CommonUtil.formatToUtc(),
    paymentGenerationDate: CommonUtil.formatToUtc(),
    subscriptionId: "",
    code: "",
    isSentEmailToCustomer: false,
  });
  const [profile, setProfile] = useState("");
  const [InavalidprofilePhoto, setInavalidprofilePhoto] = useState(false);
  const [countries, setCountries] = React.useState([]);
  const [tabValue, setTabValue] = useState();
  const [phoneInput, setPhoneInput] = useState("");
  const [billingPhoneInput, setBillingPhoneInput] = useState("");
  const [createCustomer, setcreateCustomer] = useState(true);
  const [authentication, setAuthentication] = useState(true);
  const [autoRenewal, setAutoRenewal] = useState("");
  const [expiryRemind, setExpiryRemind] = useState("");
  const [profileImage, setProfileImage] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const [disable, setDisable] = useState(true);
  const [customerProfile, setCustomerProfile] = useState("customerProfile");
  const [planExpirationReminder, setPlanExpirationReminder] = useState(false);
  const [companyCountry] = useState(props.location.country);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [currentFilter, setCurrentFilter] = useState({
    companyId: props.location.state ? props.location.state.id : "",
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
    ],
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
    ],
  });
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [checkConvertToYearlyPlan, setCheckConvertToYearlyPlan] = useState(
    false
  );
  const [showConvertPlanYearly, setShowConvertPlanYearly] = useState(false);
  const [state, setState] = useState({
    accountState: false,
  });
  const [dealerSubscriptionId, setDealerSubscriptionId] = useState("");
  const [subscriptionName, setSubscriptionName] = useState("");
  const [discount, setDiscount] = useState();
  const [openPlanSelectDialog, setOpenPlanSelectDialog] = useState(false);
  const [openPlanPurchaseDialog, setOpenPlanPurchaseDialog] = useState(false);
  const [showPlanAssignment, setShowPlanAssignment] = useState(true);
  const [clearPlanTextField, setClearPlanTextField] = useState(false);
  const [productsResponse, setProductsResponse] = useState([]);
  const [purchasedProductsList, setPurchasedProductsList] = useState([]);
  const [hardwareDevices, setHardwareDevices] = useState([]);
  const [accessoryDevices, setAccessoryDevices] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [isPurchasedLoaded, setIsPurchasedLoaded] = useState(false);
  const [updatedProducts, setUpdatedProducts] = useState([]);
  const [
    checkShouldSendEmailToCustomer,
    setCheckShouldSendEmailToCustomer,
  ] = useState(false);

  const [error, setError] = useState({
    id: false,
    firstName: false,
    LastName: false,
    email: false,
    phone: false,
    companyName: false,
    companyCode: false,
    addressLine1: false,
    addressLine2: false,
    country: false,
    state: false,
    city: false,
    postCode: false,
    profile: false,
    subscription: false,
    subscriptionName: false,
    code: false,
  });

  useEffect(() => {
    document.body.style.overflow = "hidden"; // Disable scrolling

    return () => {
      document.body.style.overflow = "auto"; // Enable scrolling when component unmounts
    };
  }, []);

  useEffect(() => {
    if (props.location.state != null) {
      dispatch(getCustomerSubscription(props.location.state.id))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            setCurrentSubscription(res.data.subscriptionPurchaseId);
            setAssignedSubscription(res.data.subscriptionPurchaseId);
            setSubscriptionId(res.data.subscriptionPurchaseId.id);
          }
        });
    }
  }, []);

  useEffect(() => {
    if (
      props.location.state === undefined ||
      props.location.state.phone === ""
    ) {
      loadParentCompany();
    }
  }, [props.location.state]);

  const loadParentCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setParentCompanyCountry(countryCode);
          }
        }
      })
      .catch((er) => {});
  };

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  useEffect(() => {
    if (props.location.state != null) {
      setIsEditable(true);
      setPayload({
        ...payload,
        email: props.location.state.email,
        phoneCountryCode: props.location.state.phone
          ? props.location.state.phone.split("-")[0]
          : "",
        phone: props.location.state.phone
          ? props.location.state.phone.split("-")[1]
          : "",
        name: props.location.state.name,
        address: props.location.state.address,
        country: props.location.state.country,
        state: props.location.state.state,
        city: props.location.state.city,
        pincode: props.location.state.pincode,
        companyId: props.location.state.id,
        code: props.location.state.code,
        subscriptionId: subscriptionId ? subscriptionId : "",
      });
      setState({
        ...state,
        accountState: props.location.state.status === "ACTIVE" ? true : false,
      });
      setProfile(props.location.state.imagePreSignedURL);
      setPhoneInput(props.location.state.phone);
      setBillingPhoneInput(props.location.state.billingUserPhone);
      setSubscriptionName(props.location.state.subscriptionName);
      setCheckShouldSendEmailToCustomer(
        props.location.state.sentEmailToCustomer
      );
      const selectedCountry = countryData.find(
        (country) => country.name === props.location.state.country
      );
      setSelectedCountry(selectedCountry);
      setShowPlanAssignment(
        props.location.state.subscriptionName ? false : true
      );
      setClearPlanTextField(true);
    }
  }, [!payload.firstName && !payload.lastName && !payload.subscriptionId]);

  useEffect(() => {
    if (props.location.state != null) {
      dispatch(getUserInfoPro(props.location.state.email))
        .unwrap()
        .then((res) => {
          if (res.code === "UASI0033") {
            setPayload({
              ...payload,
              firstName: res.data.firstName,
              lastName: res.data.lastName,
            });
          }
        });
    }
  }, []);

  useEffect(() => {
    setCountries(countryData);
    setInavalidprofilePhoto(false);
  }, []);

  useEffect(() => {
    if (props.location?.state?.id) {
      loadPurchasedProducts();
      loadProducts();
    } else {
      loadProducts();
    }
  }, [props.location?.state?.id]);

  useEffect(() => {
    if (purchasedProductsList.length > 0 && !isPurchasedLoaded) {
      loadProducts();
      setIsPurchasedLoaded(true);
    }
  }, [purchasedProductsList]);

  const loadPurchasedProducts = () => {
    dispatch(purchasedProducts(props.location?.state?.id))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000") {
          setPurchasedProductsList(res.data);
          setIsPurchasedLoaded(false);
        } else {
          setIsPurchasedLoaded(false);
        }
      });
  };

  const loadProducts = () => {
    dispatch(getAssignedProducts(localStorage.getItem("companyId")))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000") {
          setProductsResponse(res.data);
          let hardWareDevices = res.data
            .filter((product) => product.productType === "HARDWARE")
            .map((product) => {
              const purchasedProduct = purchasedProductsList.find(
                (purchased) =>
                  purchased.stripeProductId === product.stripeProductId
              );
              return {
                ...product,
                quantity: purchasedProduct ? purchasedProduct.quantity : 0,
                minQuantity: purchasedProduct ? purchasedProduct.quantity : 0,
                frequency: purchasedProduct
                  ? purchasedProduct.frequency
                  : "month",
                disabled:
                  purchasedProduct && purchasedProduct.quantity > 0
                    ? true
                    : false,
                subscriptionItemId: purchasedProduct
                  ? purchasedProduct.subscriptionItemId
                  : "",
                stripeSubscriptionId: purchasedProduct
                  ? purchasedProduct.stripeSubscriptionId
                  : "",
                ...(purchasedProduct && {
                  ...purchasedProduct,
                }),
              };
            });
          let accessoryDevices = res.data
            .filter((product) => product.productType === "ACCESSORY")
            .map((product) => {
              const totalQuantity = purchasedProductsList
                .filter(
                  (purchased) =>
                    purchased.stripeProductId === product.stripeProductId
                )
                .reduce((sum, purchased) => sum + purchased.quantity, 0);

              return {
                ...product,
                quantity: totalQuantity > 0 ? totalQuantity : 0,
                minQuantity: totalQuantity > 0 ? totalQuantity : 0,
                frequency: "onetime",
              };
            });

          console.log(accessoryDevices);

          setHardwareDevices(hardWareDevices);
          setAccessoryDevices(accessoryDevices);
        }
      });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setcreateCustomer(event.target.checked);
    setAuthentication(event.target.checked);
    setAutoRenewal(event.target.checked);
    setExpiryRemind(event.target.checked);
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
  };

  const handlePlanAssignmentChange = (event) => {};
  const handleCheckBoxSelfProfilePhoto = () => {
    setPlanExpirationReminder(!planExpirationReminder);
  };

  const handleProfilePicture = (data) => {
    setProfile(data.base64);
    setProfileImage(data.file);

    setPayload({
      ...payload,
      companyLogo: payload.name,
      companyImageData: data.base64,
    });
  };

  const onNext = () => {
    if (CommonUtil.isEmptyString(payload.firstName)) {
      Toast(t("USERPROFSCREEN007"), "error");
      setError({ ...error, firstName: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.email)) {
      Toast(t("EMAILVALIDATE"), "error");
      setError({ ...error, email: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.name)) {
      Toast(t("DEALERCOMPANYERROR"), "error");
      setError({ ...error, name: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.address)) {
      Toast(t("DEALERADDRESSERROR"), "error");
      setError({ ...error, address: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.code)) {
      Toast(t("USERPROFSCREEN015"), "error");
      setError({ ...error, code: true });
      return false;
    }
    if (payload.code.length > 36) {
      Toast(t("USERPROFSCREEN016"), "error");
      setError({ ...error, code: true });
      return false;
    }

    const validatePayloadCode = (code) => {
      const pattern = /^[a-zA-Z0-9]([-a-zA-Z0-9_]*[a-zA-Z0-9])?$/;
      return pattern.test(code);
    };

    if (!validatePayloadCode(payload.code)) {
      Toast(t("USERPROFSCREEN017"), "error");
      setError({ ...error, code: true });
      return false;
    }

    if (!InavalidprofilePhoto) {
    } else {
      Toast("Image size should be less than 2MB", "error");
    }

    setSelectedOption("2");
  };

  const onCancel = () => {
    history.push("/vis/customerList");
  };
  const [selectedOption, setSelectedOption] = React.useState("1");
  const handleChanges = (event, newValue) => {
    setSelectedOption(newValue);
  };

  const [subscriptions, setSubscriptions] = useState([]);

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    setPayload({
      ...payload,
      phoneCountryCode: "+" + data.dialCode,
      phone: value.toString().replace(data.dialCode, ""),
    });
    setError({ phone: false });
  };

  const uploadProfilePhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data.data.imagePreSignedURL);
    bodyFormData.append("file", profileImage);
    axios({
      method: "post",
      url: "/web/employee/profile",
      data: bodyFormData,
      Authorization: localStorage.getItem("VISJwtToken"),
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function(response) {})
      .catch(function(response) {});
  };

  const handleNext = () => {
    if (CommonUtil.isEmptyString(subscriptionName)) {
      Toast(t("DEALERSUBSCRIPTIONEMPTY"), "error");
      setError({ ...error, subscriptionName: true });
      return false;
    }
    setSelectedOption("3");
  };

  const handleCheck = () => {
    const items = hardwareDevices.concat(accessoryDevices);
    console.log(items);
  };

  const handleConfirm = () => {
    if (CommonUtil.isEmptyString(payload.firstName)) {
      Toast(t("USERPROFSCREEN007"), "error");
      setError({ ...error, firstName: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.email)) {
      Toast(t("EMAILVALIDATE"), "error");
      setError({ ...error, email: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.name)) {
      Toast(t("DEALERCOMPANYERROR"), "error");
      setError({ ...error, name: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.address)) {
      Toast(t("DEALERADDRESSERROR"), "error");
      setError({ ...error, address: true });
      return false;
    }

    if (CommonUtil.isEmptyString(subscriptionName)) {
      Toast(t("DEALERSUBSCRIPTIONEMPTY"), "error");
      setError({ ...error, subscriptionName: true });
      return false;
    }

    const dto = {
      ...payload,
      status: state.accountState ? "ACTIVE" : "INACTIVE",
      sentEmailToCustomer: checkShouldSendEmailToCustomer,
      companyLogo: payload.companyImageData ? payload.name : "",
      subscriptionId: subscriptionId ? subscriptionId : "",
      products: hardwareDevices
        .concat(accessoryDevices)
        .filter((product) => product.quantity > 0),
      updatedProducts: updatedProducts.filter(
        (products) => products.quantity > 0
      ),
    };
    if (props.location.state === undefined) {
      dispatch(CreateCustomerCompany(dto))
        .unwrap()
        .then(async (data) => {
          switch (data.code) {
            case "MSGS4012":
              if (!CommonUtil.isEmptyString(data.data.imagePreSignedURL)) {
                await uploadProfilePhoto(data);
              }
              Toast(t("CREATECUSTOMERSUCCESS"), "success");
              history.push("/vis/customerList");
              break;
            case "MSGE4015":
              Toast(t("COMPANYNAMEALREADYPERSENT"), "error");
              break;
            default:
              Toast(data.message, "error");
              break;
          }
        });
    } else {
      dispatch(updateCustomerAccount(dto))
        .unwrap()
        .then(async (data) => {
          switch (data.code) {
            case "MSGS4013":
              if (!CommonUtil.isEmptyString(data.data.imagePreSignedURL)) {
                await uploadProfilePhoto(data);
              }
              Toast(t("UPDATECUSTOMERSUCCESS"), "success");
              history.push("/vis/customerList");
              break;
            case "MSGE4015":
              Toast(t("COMPANYNAMEALREADYPERSENT"), "error");
              break;
            default:
              Toast(data.message, "error");
              break;
          }
        });
    }
  };

  const handleCountryChange = (event, value) => {
    setSelectedCountry(value);
    setPayload({
      ...payload,
      country: value.name,
    });
  };

  const handlePlanCheckBox = () => {
    setShowConvertPlanYearly(false);
    setCheckConvertToYearlyPlan(false);
  };

  const handleClearField = () => {
    setSubscriptionName("");
    setShowPlanAssignment(true);
    setClearPlanTextField(false);
  };

  const handlePurchasedPlan = (data) => {
    setPayload({
      ...payload,
      subscriptionId: data.id,
    });
    setSubscriptionId(data.id);
    setSubscriptionName(data.subscriptionName);
    setShowPlanAssignment(false);
    setClearPlanTextField(true);
    setOpenPlanPurchaseDialog(false);
  };

  const handlePlanSelected = (data) => {
    setPayload({
      ...payload,
      subscriptionId: data.id,
    });
    setSubscriptionId(data.id);
    setSubscriptionName(data.subscriptionName);
    setShowPlanAssignment(false);
    setClearPlanTextField(true);
  };

  const hardwareDevices1 = productsResponse
    .filter((product) => product.productType === "HARDWARE")
    .map((product) => ({
      ...product,
      quantity: 0,
    }));

  const accessoryDevices1 = productsResponse
    .filter((product) => product.productType === "ACCESSORY")
    .map((product) => ({
      ...product,
      quantity: 0,
    }));

  const handleIncrease = (index) => {
    const updatedDevices = [...hardwareDevices];
    updatedDevices[index].quantity = (updatedDevices[index].quantity || 0) + 1;
    updatedDevices[index].newQuantity += 1;
    setHardwareDevices(updatedDevices);
    if (props.location.state != null) {
      setUpdatedProducts((prevProducts) => {
        const existingIndex = prevProducts.findIndex(
          (item) => item.id === updatedDevices[index].id
        );

        if (existingIndex !== -1) {
          const newProducts = [...prevProducts];
          newProducts[existingIndex] = updatedDevices[index];
          return newProducts;
        } else {
          return [...prevProducts, updatedDevices[index]];
        }
      });
    }
  };

  const handleDecrease = (index) => {
    const updatedDevices = [...hardwareDevices];
    if (updatedDevices[index].quantity > 0) {
      updatedDevices[index].quantity -= 1;
      setHardwareDevices(updatedDevices);
      if (props.location.state != null) {
        setUpdatedProducts((prevProducts) => {
          const existingIndex = prevProducts.findIndex(
            (item) => item.id === updatedDevices[index].id
          );

          if (existingIndex !== -1) {
            const newProducts = [...prevProducts];
            newProducts[existingIndex] = updatedDevices[index];
            return newProducts;
          } else {
            return [...prevProducts, updatedDevices[index]];
          }
        });
      }
    }
  };

  const handleIncreaseAccessory = (index) => {
    const updatedDevices = [...accessoryDevices];
    updatedDevices[index].quantity = (updatedDevices[index].quantity || 0) + 1;
    updatedDevices[index].newQuantity += 1;
    setAccessoryDevices(updatedDevices);
    if (props.location.state != null) {
      setUpdatedProducts((prevProducts) => {
        const existingIndex = prevProducts.findIndex(
          (item) => item.id === updatedDevices[index].id
        );

        if (existingIndex !== -1) {
          const newProducts = [...prevProducts];
          newProducts[existingIndex] = updatedDevices[index];
          return newProducts;
        } else {
          return [...prevProducts, updatedDevices[index]];
        }
      });
    }
  };

  const handleDecreaseAccessory = (index) => {
    const updatedDevices = [...accessoryDevices];
    if (updatedDevices[index].quantity > 0) {
      updatedDevices[index].quantity -= 1;
      setAccessoryDevices(updatedDevices);
      if (props.location.state != null) {
        setUpdatedProducts((prevProducts) => {
          const existingIndex = prevProducts.findIndex(
            (item) => item.id === updatedDevices[index].id
          );

          if (existingIndex !== -1) {
            const newProducts = [...prevProducts];
            newProducts[existingIndex] = updatedDevices[index];
            return newProducts;
          } else {
            return [...prevProducts, updatedDevices[index]];
          }
        });
      }
    }
  };

  const handleToggle = (index) => {
    setHardwareDevices((prevDevices) =>
      prevDevices.map((device, i) =>
        i === index
          ? {
              ...device,
              frequency: device.frequency === "monthly" ? "onetime" : "monthly",
            }
          : device
      )
    );
  };

  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;
      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  const handleCheckBox = (event) => {
    const isChecked = event.target.checked;
    setCheckShouldSendEmailToCustomer(isChecked);
    setPayload((prevPayload) => ({
      ...prevPayload,
      sentEmailToCustomer: isChecked,
    }));
  };

  return (
    <>
      <HeaderToolbar
        back_button={true}
        title={
          isEditable
            ? t("LABELNAVITEMSEDITCUSTOMER")
            : t("LABELNAVITEMSCREATECUSTOMER")
        }
      />

      <Paper
        style={{
          height: `${height}px`,
          overflowY: "auto",
          marginTop: "15px",
        }}
      >
        <TabContext value={selectedOption}>
          <Box sx={{ ml: 3 }}>
            <TabList
              onChange={handleChanges}
              aria-label="tab"
              sx={{
                boxShadow: "none",
                borderBottom: "1px solid #f1f1f1",
              }}
              TabIndicatorProps={{
                sx: {
                  backgroundColor: "#f2824c",
                  height: "3px",
                  borderRadius: "2px",
                },
              }}
            >
              <Tab
                sx={{
                  ml: 3,
                  color: "gray",
                  "&.Mui-selected": { color: "#333" },
                  fontWeight: "500",
                  textTransform: "capitalize",
                }}
                icon={<ProfileIcon />}
                iconPosition="start"
                label={t("DEALERTABPROFILE")}
                value="1"
                onClick={handlePlanCheckBox}
              />
              <Tab
                sx={{
                  ml: 8,
                  color: "gray",
                  "&.Mui-selected": { color: "#333" },
                  fontWeight: "500",
                  textTransform: "capitalize",
                }}
                icon={<PaymentIcon />}
                iconPosition="start"
                label={t("DEALERTABSUBSCRIPTION")}
                value="2"
              />
              {/* <Tab
                sx={{
                  ml: 8,
                  color: "gray",
                  "&.Mui-selected": { color: "#333" },
                  fontWeight: "500",
                  textTransform: "capitalize",
                }}
                label={t("PRODUCTS")}
                value="3"
              /> */}
            </TabList>
          </Box>
          <TabPanel
            value="1"
            style={{
              padding: "0px",
            }}
          >
            <Grid container p={2}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                md={4}
                sm={12}
              >
                <Grid sm={7}>
                  <ProfileUplod
                    onsetProfile={(profile) => handleProfilePicture(profile)}
                    profilePhoto={profile}
                    uploadPhoto={customerProfile}
                  />
                </Grid>
              </Grid>
              <Grid container md={8} sm={12} spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERFIRSTNAME")}
                    name={"firstName"}
                    value={payload.firstName}
                    required={true}
                    error={error.firstName}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERLASTNAME")}
                    name={"lastName"}
                    value={payload.lastName}
                    error={error.lastName}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALEREMAIL")}
                    name={"email"}
                    value={payload.email}
                    error={error.email}
                    disabled={isEditable}
                    validation="email"
                    required={true}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 150 }}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <SelfRegistrationCustomPhone
                    placeholder={t("CUSTDATABLE03")}
                    value={phoneInput}
                    country={
                      parentCompanyCountry === "" ? "us" : parentCompanyCountry
                    }
                    specialLabel={false}
                    handleChange={(value, data, event, formattedValue) =>
                      handlePhoneChange(value, data, event, formattedValue)
                    }
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERCOMPANYNAME")}
                    name={"name"}
                    value={payload.name}
                    required={true}
                    error={error.name}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERADDRESSLINE")}
                    name={"address"}
                    value={payload.address}
                    error={error.address}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 200 }}
                    required={true}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERCITY")}
                    name={"city"}
                    value={payload.city}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERSTATE")}
                    name={"state"}
                    value={payload.state}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={countries}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField {...params} label={t("DEALERCOUNTRY")} />
                    )}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                  <CustomTextfeild
                    label={t("DEALERZIPCODE")}
                    name={"pincode"}
                    value={payload.pincode}
                    validation="alphaNumericWithSpace"
                    handleChange={handleChange}
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12}>
                  <CustomTextfeild
                    label={t("COMMON036")}
                    name={"code"}
                    value={payload.code}
                    error={error.code}
                    handleChange={handleChange}
                    required={true}
                    inputProps={{ maxLength: 36 }}
                    disabled={isEditable}
                    validation="alpha-numeric"
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={6} md={6} xl={12}></Grid>
              </Grid>
              <Grid container lg={4}></Grid>
              <Grid container lg={8} pr={1.5} justifyContent="flex-end">
                <Grid pr={2}>
                  <CancelButtons
                    variant="contained"
                    color="secondary"
                    onClick={onCancel}
                  >
                    <Typography>{t("COMMON008")}</Typography>
                  </CancelButtons>
                </Grid>
                <Grid>
                  <SubmitButtons variant="contained" onClick={onNext}>
                    <Typography>{t("DEALERNEXT")}</Typography>
                  </SubmitButtons>
                </Grid>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value="2">
            <Grid container spacing={2} sx={{ backgroundColor: "#ffffff" }}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h4"
                  sx={{ textAlign: { xs: "center", md: "left" } }}
                >
                  {t("DEALERPLANDETAILS")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ textAlign: { xs: "center", md: "right" } }}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked
                        checked={planExpirationReminder}
                        onChange={handleCheckBoxSelfProfilePhoto}
                        sx={{ "&.Mui-checked": { color: "#F2824C" } }}
                      />
                    }
                    label={t("DEALERREMIND")}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomTextfeild
                  label={t("DEALERPLACEHOLDER1")}
                  name="subscriptionName"
                  value={subscriptionName}
                  error={error.subscriptionName}
                  required
                  handleChange={handlePlanAssignmentChange}
                  InputProps={{
                    endAdornment: clearPlanTextField ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClearField}
                          sx={{
                            position: "absolute",
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  // justifyContent: "center",
                  gap: 2,
                  mt: 2,
                  // marginRight: "68%",
                }}
              >
                <Button
                  onClick={() => setOpenPlanPurchaseDialog(true)}
                  style={{
                    backgroundColor: "#F8F8F8",
                    border: "2px solid #F2824CB3",
                    color: "#F2824C",
                    width: "150px",
                    height: "28px",
                    borderRadius: "20px",
                  }}
                >
                  {t("DEALERPURCHASEPLAN")}
                </Button>
                <Button
                  onClick={() => setOpenPlanSelectDialog(true)}
                  style={{
                    backgroundColor: "#F8F8F8",
                    border: "2px solid #F2824CB3",
                    color: "#F2824C",
                    width: "150px",
                    height: "28px",
                    borderRadius: "20px",
                  }}
                >
                  {t("DEALERPLANASSIGNMENT")}
                </Button>
              </Grid>
            </Grid>

            <Grid container md={6} sm={12} spacing={2}>
              <Grid
                item
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{
                  marginTop: 5,
                  paddingRight: "0px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <SubmitButtons variant="contained" onClick={handleConfirm}>
                  <Typography>{t("COMMON007")}</Typography>
                </SubmitButtons>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel
            value="3"
            style={{
              padding: "16px",
            }}
          >
            <Box>
              <Grid
                style={{
                  backgroundColor: "white",
                  overflowY: "scroll",
                  scrollbarWidth: "none",
                  borderRadius: "10px",
                }}
                spacing={2}
              >
                {hardwareDevices.length > 0 && (
                  <Grid container spacing={2} padding={2}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        background:
                          "transparent linear-gradient(270deg, #F2F2F21A 0%, #E9E9E9 100%) 0% 0% no-repeat padding-box",
                        borderRadius: "10px",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#474A4E",
                          fontSize: "20px",
                          fontFamily: "font_semiBold",
                          marginBottom: "10px",
                        }}
                      >
                        {t("CUSTOMER_PRODUCT_ASSIGNMENT")}
                      </Typography>
                    </Grid>
                    {hardwareDevices.map((product, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          right: "12px",
                        }}
                      >
                        <Box
                          position="relative"
                          style={{
                            height: "150px",
                            backgroundColor: "#F9F9F9",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10px",
                          }}
                        >
                          <Box
                            style={{
                              height: "92px",
                              width: "92px",
                              backgroundColor: "#D8D8D8",
                              borderRadius: "12px",
                            }}
                          >
                            <img
                              src={product.productImagePresignedUrl}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "12px",
                              }}
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            overflow: "hidden",
                            wordWrap: "break-word",
                            textOverflow: "ellipsis",
                            flex: 1,
                          }}
                        >
                          <Typography
                            style={{
                              color: "#474A4E",
                              fontSize: "18px",
                              fontFamily: "font_bold",
                              whiteSpace: "normal",
                              wordBreak: "break-word", // Ensures long words break to the next line
                              overflowWrap: "break-word", // Prevents text overflow
                              textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                              display: "-webkit-box",
                              WebkitLineClamp: 1, // Limits the number of lines to 1
                              WebkitBoxOrient: "vertical",
                              maxWidth: "100%", // Ensures it does not exceed the container
                              overflow: "hidden",
                            }}
                          >
                            <Tooltip
                              title={
                                product.productName +
                                (product.productModel
                                  ? " " + product.productModel
                                  : "")
                              }
                            >
                              {product.productModel
                                ? `${product.productName} + ${product.productModel}`
                                : `${product.productName}`}
                            </Tooltip>
                          </Typography>
                          <Typography
                            style={{
                              color: "#226BAB",
                              fontSize: "16px",
                              fontFamily: "font_semiBold",
                            }}
                          >
                            Monthly - ${product.monthlyPrice} / Onetime - $
                            {product.oneTimePrice}
                          </Typography>
                          <Tooltip title={product.description}>
                            <Typography
                              style={{
                                color: "#474A4E",
                                fontSize: "14px",
                                fontFamily: "font_regular",
                                whiteSpace: "normal",
                                wordBreak: "break-word", // Ensures long words break to the next line
                                overflowWrap: "break-word", // Prevents overflow
                                textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                                display: "-webkit-box",
                                WebkitLineClamp: 3, // Limits the number of lines
                                WebkitBoxOrient: "vertical",
                                maxWidth: "100%", // Prevents width overflow
                              }}
                            >
                              {product.description}
                            </Typography>
                          </Tooltip>
                        </Box>
                        <Stack direction="row" spacing={2}>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="8px"
                            border="2px solid #E0E0E0"
                            width="30%"
                            // p={1}
                            mt={2}
                          >
                            <IconButton
                              onClick={() => handleDecrease(index)}
                              disabled={product.quantity <= product.minQuantity}
                            >
                              <RemoveIcon
                                sx={{
                                  color: "#828282",
                                }}
                              />
                            </IconButton>
                            <Typography mx={2}>
                              {product.quantity || 0}
                            </Typography>
                            <IconButton onClick={() => handleIncrease(index)}>
                              <AddIcon
                                sx={{
                                  color: "#828282",
                                }}
                              />
                            </IconButton>
                          </Box>
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                          >
                            <Stack
                              direction="row"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography>Monthly</Typography>
                              <Android12Switch
                                checked={product.frequency === "onetime"}
                                onChange={() => handleToggle(index)}
                                disabled={product.disabled}
                              />
                              <Typography>Onetime</Typography>
                            </Stack>
                          </Box>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                )}

                {/* Accessory Section */}
                {accessoryDevices.length > 0 && (
                  <Grid container spacing={2} padding={2}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        background:
                          "transparent linear-gradient(270deg, #F2F2F21A 0%, #E9E9E9 100%) 0% 0% no-repeat padding-box",
                        borderRadius: "10px",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#474A4E",
                          fontSize: "20px",
                          fontFamily: "font_semiBold",
                          marginBottom: "10px",
                        }}
                      >
                        {t("ACCESSORIES")}
                      </Typography>
                    </Grid>
                    {accessoryDevices.map((product, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          right: "12px",
                        }}
                      >
                        <Box
                          position="relative"
                          style={{
                            height: "150px",
                            backgroundColor: "#F9F9F9",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10px",
                          }}
                        >
                          <Box
                            style={{
                              height: "92px",
                              width: "92px",
                              backgroundColor: "#D8D8D8",
                              borderRadius: "12px",
                            }}
                          >
                            <img
                              src={product.productImagePresignedUrl}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "12px",
                              }}
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            overflow: "hidden",
                            wordWrap: "break-word",
                            textOverflow: "ellipsis",
                            flex: 1,
                          }}
                        >
                          <Typography
                            style={{
                              color: "#474A4E",
                              fontSize: "18px",
                              fontFamily: "font_bold",
                              whiteSpace: "normal",
                              wordBreak: "break-word", // Ensures long words break to the next line
                              overflowWrap: "break-word", // Prevents text overflow
                              textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                              display: "-webkit-box",
                              WebkitLineClamp: 1, // Limits the number of lines to 2
                              WebkitBoxOrient: "vertical",
                              maxWidth: "100%", // Ensures it does not exceed the container
                              overflow: "hidden",
                            }}
                          >
                            <Tooltip
                              title={product.productModel || ""}
                              placement="bottom-start"
                            >
                              <span>
                                {product.productModel
                                  ? `${product.productName} + ${product.productModel}`
                                  : product.productName}
                              </span>
                            </Tooltip>
                          </Typography>
                          <Typography
                            style={{
                              color: "#226BAB",
                              fontSize: "16px",
                              fontFamily: "font_semiBold",
                            }}
                          >
                            Monthly - ${product.monthlyPrice} / Onetime - $
                            {product.oneTimePrice}
                          </Typography>
                          <Tooltip title={product.description}>
                            <Typography
                              style={{
                                color: "#474A4E",
                                fontSize: "14px",
                                fontFamily: "font_regular",
                                whiteSpace: "normal",
                                wordBreak: "break-word", // Ensures long words break to the next line
                                overflowWrap: "break-word", // Prevents overflow
                                textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                                display: "-webkit-box",
                                WebkitLineClamp: 3, // Limits the number of lines
                                WebkitBoxOrient: "vertical",
                                maxWidth: "100%", // Prevents width overflow
                              }}
                            >
                              {product.description}
                            </Typography>
                          </Tooltip>
                        </Box>

                        <Stack direction="row" spacing={2}>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="8px"
                            border="2px solid #E0E0E0"
                            width="30%"
                            // p={1}
                            mt={2}
                          >
                            <IconButton
                              onClick={() => handleDecreaseAccessory(index)}
                              disabled={product.quantity <= product.minQuantity}
                            >
                              <RemoveIcon
                                sx={{
                                  color: "#828282",
                                }}
                              />
                            </IconButton>
                            <Typography mx={2}>
                              {product.quantity || 0}
                            </Typography>
                            <IconButton
                              onClick={() => handleIncreaseAccessory(index)}
                            >
                              <AddIcon
                                sx={{
                                  color: "#828282",
                                }}
                              />
                            </IconButton>
                          </Box>
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                          >
                            {/* <Stack
                                direction="row"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Typography>Monthly</Typography>
                                <Android12Switch
                                  checked={product.frequency === "onetime"}
                                  onChange={() => handleToggle(index)}
                                  disabled={product.disabled}
                                />
                                <Typography>Onetime</Typography>
                              </Stack> */}
                          </Box>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                )}
                <FormControlLabel
                  style={{ marginLeft: "-6px" }}
                  control={
                    <Checkbox
                      sx={{
                        color: "#F2824C",
                        "&.Mui-checked": {
                          color: "#F2824C",
                        },
                      }}
                      checked={checkShouldSendEmailToCustomer}
                      onChange={handleCheckBox}
                    />
                  }
                  label="Delivery to Customer"
                />
              </Grid>
              <Grid
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "16px",
                }}
              >
                <SubmitButtons variant="contained" onClick={handleConfirm}>
                  <Typography>{t("confirmVisitorButton")}</Typography>
                </SubmitButtons>
              </Grid>
            </Box>
          </TabPanel>
        </TabContext>
      </Paper>
      {openPlanPurchaseDialog && (
        <PlanPurchaseDialogBox
          open={openPlanPurchaseDialog}
          handleClose={() => {
            setOpenPlanPurchaseDialog(false);
          }}
          handlePurchasedPlan={handlePurchasedPlan}
        />
      )}
      {openPlanSelectDialog && (
        <SelectPlanDialogBox
          open={openPlanSelectDialog}
          handleClose={() => {
            setOpenPlanSelectDialog(false);
          }}
          handlePlanSelected={handlePlanSelected}
        />
      )}
    </>
  );
}

export default CreateCustomer;
